import {ReactSVG} from 'react-svg';
import {FaCircle} from 'react-icons/fa'

import {IconContext} from "react-icons";
import {useRef, useState, useCallback} from 'react';

import {PiApproximateEqualsDuotone} from "react-icons/pi";
import {PiSubtractSquareDuotone} from "react-icons/pi";
import {MdOutlineGradient} from "react-icons/md";
import {MdLocalGroceryStore} from "react-icons/md";
import {IoStorefrontSharp} from "react-icons/io5";
import FruitsPear from "../pages/fruits-pear-svgrepo-com.svg";
import Warehouse from "../pages/warehouse-svgrepo-com.svg";
import {MdInvertColors} from "react-icons/md";
import {PiCircleHalfTiltDuotone} from "react-icons/pi";
import {PiSquareHalfDuotone} from "react-icons/pi";
import {PiSubtractSquareLight} from "react-icons/pi";
import {PiExcludeSquareDuotone} from "react-icons/pi";
import {PiCellSignalMediumDuotone} from "react-icons/pi";
import {AiFillMinusCircle, AiTwotonePlusCircle} from "react-icons/ai";
import {AiOutlinePlus} from "react-icons/ai";
import {AiOutlineMinus} from "react-icons/ai";

import {BsFillPlusCircleFill} from "react-icons/bs";
import {GoPlusCircle} from "react-icons/go";
import {CiCircleMinus} from "react-icons/ci";
import {CiCirclePlus} from "react-icons/ci";
import {BsPlusCircle} from "react-icons/bs";
import {AiOutlinePlusCircle} from "react-icons/ai";
import {AiOutlineMinusCircle} from "react-icons/ai";


import {FiPlusCircle} from "react-icons/fi";
import {FiMinusCircle} from "react-icons/fi";

import * as React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from "react-bootstrap/Button";
import {MdOutlineVisibilityOff} from "react-icons/md";
import {MdOutlineVisibility} from "react-icons/md";
import {IoLayersOutline} from "react-icons/io5";
import {IoLayers} from "react-icons/io5";
import {SlLayers} from "react-icons/sl";
import {IoLayersSharp} from "react-icons/io5";
import {Range} from "react-range";
// import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
// import Slider from '@react-native-community/slider';
import RangeSlider from 'react-bootstrap-range-slider';
import Slider from "@material-ui/core/Slider";
import {FaBasketShopping} from "react-icons/fa6";


// const layerTree = [
//         {
//             id: 1,
//             title: "Climate & Environment",
//             hasCheckbox: false,
//             children: [
//                 {
//                     id: "climateZones",
//                     title: "Climate Zone",
//                     hasCheckbox: true,
//                 }, {
//                     id: "precip",
//                     title: "Precipitation",
//                     hasCheckbox: true,
//                 }, {
//                     id: "temperature",
//                     title: "Temperature",
//                     hasCheckbox: true,
//                 }, {
//                     id: "solarInsolation",
//                     title: "Solar Insolation",
//                     hasCheckbox: true,
//                 }, {
//                     //     id: "windRsrcPotential",
//                     //     title: "Wind Resource Potential",
//                     //     hasCheckbox: true,
//                     // }, {
//                     id: "geothermWellsSprings",
//                     title: "Geothermal Wells & Springs",
//                     hasCheckbox: true,
//                 }, {
//                     id: "geothermTemp",
//                     title: "Geothermal Temperature",
//                     hasCheckbox: true,
//                 }, {
//                     id: "geothermBounds",
//                     title: "Geothermal Boundaries",
//                     hasCheckbox: true,
//                 }, {
//                     id: "soils",
//                     title: "Soil Properties",
//                     hasCheckbox: true,
//                 }, {
//                     id: "airQual",
//                     title: "Air Quality",
//                     hasCheckbox: true,
//                 }
//             ]
//         }, {
//             id: 2,
//             title: "Land Use & Utilities",
//             hasCheckbox: false,
//             children: [
//                 {
//                     id: "zoning",
//                     title: "Land Zoning",
//                     hasCheckbox: true,
//                 }, {
//                     id: "parcel",
//                     title: "Land Parcels",
//                     hasCheckbox: true,
//                 }, {
//                     id: "landUse",
//                     title: "Land Use",
//                     hasCheckbox: true,
//                 }, {
//                     id: "farmland",
//                     title: "Conventional Farmland",
//                     hasCheckbox: true,
//                 }, {
//                     id: "crops",
//                     title: "Cropland",
//                     hasCheckbox: true,
//                 }, {
//                     id: "utilities",
//                     title: "Utilities",
//                     hasCheckbox: false,
//                     children: [{
//                         id: "wtrSrvcAreas",
//                         title: "Water Service Areas",
//                         hasCheckbox: true,
//                     }, {
//                         id: "wastewaterSrvcAreas",
//                         title: "Wastewater Service Areas",
//                         hasCheckbox: true,
//                     }, {
//                         id: "sewerSrvcAreas",
//                         title: "Sewer Service Areas",
//                         hasCheckbox: true,
//                     }, {
//                         id: "wastewaterLines",
//                         title: "Wastewater Lines",
//                         hasCheckbox: true,
//                     }, {
//                         id: "sewerLines",
//                         title: "Sewer Lines",
//                         hasCheckbox: true,
//                     }, {
//                         id: "wtrLines",
//                         title: "Water Lines",
//                         hasCheckbox: true,
//                     }, {
//                         id: "elecPwrTransLines",
//                         title: "Power Transmission Lines",
//                         hasCheckbox: true,
//                     }, {
//                         id: "natGasLines",
//                         title: "Major Natural Gas Pipelines",
//                         hasCheckbox: true,
//                     }, {
//                         id: "wastewaterTreatPlants",
//                         title: "Wastewater Treatment Plants",
//                         hasCheckbox: true,
//                     }, {
//                         id: "microgrids",
//                         title: "Microgrids",
//                         hasCheckbox: true,
//                     }, {
//                         id: "chpPlants",
//                         title: "CHP Facilities",
//                         hasCheckbox: true,
//                     }]
//                 }
//             ]
//         }, {
//             id: 3,
//             title: "Social & Economic",
//             hasCheckbox: false,
//             children: [{}, {
//                 id: "popDensity",
//                 title: "Population Density",
//                 hasCheckbox: true,
//             }, {
//                 id: "income",
//                 title: "Personal Income",
//                 hasCheckbox: true,
//             }, {
//                 id: "unemploy",
//                 title: "Unemployment Rate",
//                 hasCheckbox: true,
//             }, {
//                 //     id: "edLevel",
//                 //     title: "Education Level",
//                 //     hasCheckbox: true,
//                 // }, {
//                 //     id: "disadvCommunities",
//                 //     title: "Disadvantaged Communities",
//                 //     hasCheckbox: true,
//             }, {
//                 id: "opportunityZones",
//                 title: "Opportunity Zones",
//                 hasCheckbox: true,
//             }, {
//                 id: "foodAccess",
//                 title: "Food Access",
//                 hasCheckbox: true,
//             }]
//         }, {
//             id: 4,
//             title: "Co-Location Opportunities",
//             hasCheckbox: false,
//             children: [{
//                 id: "ceaFacilities",
//                 title: "CEA Facilities",
//                 hasCheckbox: true,
//                 // icon: <FaCircle color={'red'}/>
//                 layerType: 'circle'
//
//             }, {
//                 id: "compostFacilities",
//                 title: "Composting Facilities",
//                 hasCheckbox: true,
//                 layerType: 'circle'
//             }, {
//                 id: "foodBanks",
//                 title: "Food Banks",
//                 hasCheckbox: true,
//                 layerType: 'circle'
//             }, {
//                 id: "foodManufactProcessors",
//                 title: "Food Manufacturers & Processors",
//                 hasCheckbox: true,
//             }, {
//                 id: "refrigFacilities",
//                 title: "Refrigerated Storage",
//                 hasCheckbox: true,
//             }, {
//                 id: "farmersMarkets",
//                 title: "Farmer's Markets",
//                 hasCheckbox: true,
//             }, {
//                 id: 'pwrPlants',
//                 title: 'Power Plants',
//                 hasCheckbox: true,
//             }, {
//                 id: "foodRetailers",
//                 title: "Food Wholesalers & Retailers",
//                 hasCheckbox: false,
//                 children: [
//                     {
//                         id: "supermarkets",
//                         title: "Supermarkets & Grocery Stores",
//                         hasCheckbox: true,
//                         icon: <MdLocalGroceryStore/>
//                     }, {
//                         id: "fruitVegMarkets",
//                         title: "Fruit & Vegetable Markets",
//                         hasCheckbox: true,
//                         icon: <FaBasketShopping/>
//                     }, {
//                         id: "fruitVegWholesalers",
//                         title: "Fruit & Vegetable Wholesalers",
//                         hasCheckbox: true,
//                         icon: <ReactSVG
//                             src={FruitsPear}
//                             beforeInjection={(svg) => {
//                                 svg.setAttribute(
//                                     'style', 'width: 12px; height: 12px'
//                                 )
//                             }}
//                             wrapper={'span'}
//                         />
//                     }, {
//                         id: "warehouseClubs",
//                         title: "Warehouse Clubs & Supercenters",
//                         hasCheckbox: true,
//                         icon: <IoStorefrontSharp/>
//                     }, {
//                         id: "generalWarehousingStorage",
//                         title: "General Warehousing & Storage",
//                         hasCheckbox: true,
//                         icon: <ReactSVG
//                             src={Warehouse}
//                             beforeInjection={(svg) => {
//                                 svg.setAttribute(
//                                     'style', 'width: 12px; height: 12px'
//                                 )
//                             }}
//                             wrapper={'span'}
//                         />
//                     }
//
//                 ]
//             }, {
//                 id: "biogasFacilities",
//                 title: "Biogas Facilities",
//                 hasCheckbox: false,
//                 children: [{
//                     id: "anaerobDigesters",
//                     title: "Anaerobic Digesters",
//                     hasCheckbox: true,
//                 }, {
//                     id: 'landfills',
//                     title: 'Landfills',
//                     hasCheckbox: true,
//                 }]
//             }]
//         },
//     ]
// ;

// const debounce = (inputFun, milliseconds) => {
//     let timeout;
//
//     return (...args) => {
//         if (!timeout) {
//             inputFun(...args);
//
//             timeout = setTimeout(
//                 () => (timeout = undefined),
//                 milliseconds
//             );
//         }
//     };
// };

// This component provides a control panel for managing map layers in the UI.
// It allows users to toggle the visibility of layers, adjust their opacity,
// and explore a hierarchical tree of available map layers, including
// environmental, land use, social, and co-location opportunity layers.

function LayerControl(props) {
    const [isHovering, setIsHovering] = useState(false);

    const layers = structuredClone(props.layers);
    const layerIds = Array.from(layers, (layer) => layer.id);

    const handleHideAllLayersBtnClick = (evt) => {
        layers.forEach((layer) => {
            const layerType = layer['type'];
            var opacityProp = `${layerType}-opacity`;
            if (layerType === 'symbol') {
                opacityProp = 'icon-opacity';
            }
            const visible = layer.paint[opacityProp] != 0;
            if (visible) {
                if (layerType == 'circle') {
                    layer.paint['circle-stroke-opacity'] = 0;
                }
                layer.paint[opacityProp] = 0;
            }
            props.onChange(layers);
        });
        if (props.setSoilSlopeVisible) {
            props.setSoilSlopeVisible(false);
        }
        if (props.setLandCoverVisible) {
            props.setLandCoverVisible(false);
        }
        if (props.setCropsVisible) {
            props.setCropsVisible(false);
        }
    };

    const handleShowAllLayersBtnClick = (evt) => {
        layers.forEach((layer) => {
            const layerType = layer['type'];
            var opacityProp = `${layerType}-opacity`;
            if (layerType === 'symbol') {
                opacityProp = 'icon-opacity';
            }
            const visible = layer.paint[opacityProp] != 0;
            if (layerType == 'circle') {
                layer.paint['circle-stroke-opacity'] = 0;
            }
            layer.paint[opacityProp] = 0;
            if (layerType == 'fill') {
                layer.paint[opacityProp] = 0.5;
            } else if (layerType == 'circle') {
                layer.paint[opacityProp] = 0.9;
                layer.paint['circle-stroke-opacity'] = 1;
            } else if (layerType == 'line') {
                layer.paint[opacityProp] = 0.8;
            } else {
                layer.paint[opacityProp] = 0.6;
            }
            props.onChange(layers);
        });
        if (props.setSoilSlopeVisible) {
            props.setSoilSlopeVisible(true);
        }
        if (props.setLandCoverVisible) {
            props.setLandCoverVisible(true);
        }
        if (props.setCropsVisible) {
            props.setCropsVisible(true);
        }
    };

    const handleOpacityMinusBtnClick = (evt) => {
        const targetLayers = layers.filter((layer) =>
            layer.id.startsWith(evt.target.id)
        );
        if (targetLayers) {
            targetLayers.forEach((layer) => {
                const layerType = layer['type'];
                var opacityProp = `${layerType}-opacity`;
                if (layerType === 'symbol') {
                    opacityProp = 'icon-opacity';
                }
                const newOpacity = layer.paint[opacityProp] - 0.1;
                if (newOpacity > 0) {
                    layer.paint[opacityProp] = newOpacity;
                } else {
                    layer.paint[opacityProp] = 0;
                }
                props.onChange(layers);
            });
        }
    };

    const handleOpacityPlusBtnClick = (evt) => {
        const targetLayers = layers.filter((layer) =>
            layer.id.startsWith(evt.target.id)
        );
        if (targetLayers) {
            targetLayers.forEach((layer) => {
                const layerType = layer['type'];
                var opacityProp = `${layerType}-opacity`;
                if (layerType === 'symbol') {
                    opacityProp = 'icon-opacity';
                }
                const newOpacity = layer.paint[opacityProp] + 0.1;
                if (newOpacity <= 1) {
                    layer.paint[opacityProp] = newOpacity;
                } else {
                    layer.paint[opacityProp] = 1;
                }
                props.onChange(layers);
            });
        }
    };

    const handleLayerCheckChange = (evt) => {
        const targetLayers = layers.filter((layer) =>
            layer.id.startsWith(evt.target.id)
        );
        if (targetLayers) {
            targetLayers.forEach((layer) => {
                const layerType = layer['type'];
                var opacityProp = `${layerType}-opacity`;
                if (layerType === 'symbol') {
                    opacityProp = 'icon-opacity';
                }
                const visible = layer.paint[opacityProp] != 0;
                if (visible) {
                    if (layerType == 'circle') {
                        layer.paint['circle-stroke-opacity'] = 0;
                    }
                    layer.paint[opacityProp] = 0;
                } else {
                    if (layerType == 'fill') {
                        layer.paint[opacityProp] = 0.5;
                    } else if (layerType == 'circle') {
                        layer.paint[opacityProp] = 0.9;
                        layer.paint['circle-stroke-opacity'] = 1;
                    } else if (layerType == 'line') {
                        layer.paint[opacityProp] = 0.8;
                    } else {
                        layer.paint[opacityProp] = 0.6;
                    }
                }
                props.onChange(layers);
            });
        }
    };

    const SubLevelComp = ({ item, renderNestedLevels }) => {
        var activeCollapses = structuredClone(props.activeCollapses);
        const selected = activeCollapses.includes(item.id);
        const targetLayers = layers.filter((layer) =>
            layer.id.startsWith(item.id)
        );
        var layerVisible = false;
        var layerOpacity = 0;
        if (targetLayers.length > 0) {
            const layer = targetLayers[0];
            const layerType = layer['type'];
            var opacityProp = `${layerType}-opacity`;
            if (layerType === 'symbol') {
                opacityProp = 'icon-opacity';
            }
            layerOpacity = layer.paint[opacityProp];
            layerVisible = layer.paint[opacityProp] != 0;
        }

        const toggle = () => {
            if (activeCollapses.includes(item.id)) {
                activeCollapses = activeCollapses.filter((x) => x != item.id);
            } else {
                activeCollapses.push(item.id);
            }
            props.activeCollapsesSetter(activeCollapses);
        };

        const hasChildren = (item) => {
            return Array.isArray(item.children) && item.children.length > 0;
        };

        return (
            <div>
                <div
                    style={{
                        lineHeight: '20px',
                        cursor: hasChildren(item) ? 'pointer' : '',
                        fontWeight: hasChildren(item) ? 500 : 300,
                    }}
                    className={'d-flex align-content-center m-0'}
                >
                    {item.hasCheckbox && ((item.id === 'landCover') || (item.id === 'landCover2')) ? (
                        <div>
                            <input
                                className={'me-1 ms-2'}
                                type="checkbox"
                                id={item.id}
                                onChange={() =>
                                    props.setLandCoverVisible(
                                        !props.landCoverVisible
                                    )
                                }
                                checked={props.landCoverVisible}
                            />
                            {props.landCoverVisible && (
                                <>
                                    <Button
                                        id={item.id}
                                        variant={'outline-secondary'}
                                        style={{
                                            borderRadius: '100px',
                                            padding: '0px',
                                            height: '14px',
                                            width: '14px',
                                            marginTop: '-12px',
                                        }}
                                        onClick={() =>
                                            props.setLandCoverOpacity(
                                                Math.max(
                                                    0,
                                                    props.landCoverOpacity - 0.1
                                                )
                                            )
                                        }
                                    >
                                        <AiOutlineMinus
                                            id={item.id}
                                            size={10}
                                            style={{
                                                marginTop: '-14px',
                                                zIndex: -1,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Button>
                                    <span>
                                        <MdOutlineGradient
                                            size={17}
                                            rotation={90}
                                            style={{
                                                marginTop: '-12px',
                                                transform: 'rotate(-90deg)',
                                            }}
                                        />
                                    </span>
                                    <Button
                                        id={item.id}
                                        variant={'outline-secondary'}
                                        className={'me-1'}
                                        style={{
                                            borderRadius: '100px',
                                            padding: '0px',
                                            height: '15px',
                                            width: '15px',
                                            marginTop: '-12px',
                                        }}
                                        onClick={() =>
                                            props.setLandCoverOpacity(
                                                Math.min(
                                                    1,
                                                    props.landCoverOpacity + 0.1
                                                )
                                            )
                                        }
                                    >
                                        <AiOutlinePlus
                                            id={item.id}
                                            size={10}
                                            style={{
                                                marginTop: '-14px',
                                                zIndex: -1,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Button>
                                </>
                            )}
                        </div>
                    ) : item.hasCheckbox && item.id === 'soilSlope' ? (
                        <div>
                            <input
                                className={'me-1 ms-2'}
                                type="checkbox"
                                id={item.id}
                                onChange={() =>
                                    props.setSoilSlopeVisible(
                                        !props.soilSlopeVisible
                                    )
                                }
                                checked={props.soilSlopeVisible}
                            />
                            {props.soilSlopeVisible && (
                                <>
                                    <Button
                                        id={item.id}
                                        variant={'outline-secondary'}
                                        style={{
                                            borderRadius: '100px',
                                            padding: '0px',
                                            height: '14px',
                                            width: '14px',
                                            marginTop: '-12px',
                                        }}
                                        onClick={() =>
                                            props.setSoilSlopeOpacity(
                                                Math.max(
                                                    0,
                                                    props.soilSlopeOpacity - 0.1
                                                )
                                            )
                                        }
                                    >
                                        <AiOutlineMinus
                                            id={item.id}
                                            size={10}
                                            style={{
                                                marginTop: '-14px',
                                                zIndex: -1,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Button>
                                    <span>
                                        <MdOutlineGradient
                                            size={17}
                                            rotation={90}
                                            style={{
                                                marginTop: '-12px',
                                                transform: 'rotate(-90deg)',
                                            }}
                                        />
                                    </span>
                                    <Button
                                        id={item.id}
                                        variant={'outline-secondary'}
                                        className={'me-1'}
                                        style={{
                                            borderRadius: '100px',
                                            padding: '0px',
                                            height: '15px',
                                            width: '15px',
                                            marginTop: '-12px',
                                        }}
                                        onClick={() =>
                                            props.setSoilSlopeOpacity(
                                                Math.min(
                                                    1,
                                                    props.soilSlopeOpacity + 0.1
                                                )
                                            )
                                        }
                                    >
                                        <AiOutlinePlus
                                            id={item.id}
                                            size={10}
                                            style={{
                                                marginTop: '-14px',
                                                zIndex: -1,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Button>
                                </>
                            )}
                        </div>
                    ) : item.hasCheckbox && item.id === 'crops' ? (
                        <div>
                            <input
                                className={'me-1 ms-2'}
                                type="checkbox"
                                id={item.id}
                                onChange={() =>
                                    props.setCropsVisible(
                                        !props.cropsVisible
                                    )
                                }
                                checked={props.cropsVisible}
                            />
                            {props.cropsVisible && (
                                <>
                                    <Button
                                        id={item.id}
                                        variant={'outline-secondary'}
                                        style={{
                                            borderRadius: '100px',
                                            padding: '0px',
                                            height: '14px',
                                            width: '14px',
                                            marginTop: '-12px',
                                        }}
                                        onClick={() =>
                                            props.setCropsOpacity(
                                                Math.max(
                                                    0,
                                                    props.cropsOpacity - 0.1
                                                )
                                            )
                                        }
                                    >
                                        <AiOutlineMinus
                                            id={item.id}
                                            size={10}
                                            style={{
                                                marginTop: '-14px',
                                                zIndex: -1,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Button>
                                    <span>
                                        <MdOutlineGradient
                                            size={17}
                                            rotation={90}
                                            style={{
                                                marginTop: '-12px',
                                                transform: 'rotate(-90deg)',
                                            }}
                                        />
                                    </span>
                                    <Button
                                        id={item.id}
                                        variant={'outline-secondary'}
                                        className={'me-1'}
                                        style={{
                                            borderRadius: '100px',
                                            padding: '0px',
                                            height: '15px',
                                            width: '15px',
                                            marginTop: '-12px',
                                        }}
                                        onClick={() =>
                                            props.setCropsOpacity(
                                                Math.min(
                                                    1,
                                                    props.cropsOpacity + 0.1
                                                )
                                            )
                                        }
                                    >
                                        <AiOutlinePlus
                                            id={item.id}
                                            size={10}
                                            style={{
                                                marginTop: '-14px',
                                                zIndex: -1,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Button>
                                </>
                            )}
                        </div>    
                    ) : item.hasCheckbox && (
                        <div>
                            <input
                                className={'me-1 ms-2'}
                                type="checkbox"
                                id={item.id}
                                onChange={(evt) => handleLayerCheckChange(evt)}
                                checked={layerVisible}
                            />
                            {layerVisible && (
                                <>
                                    <Button
                                        id={item.id}
                                        variant={'outline-secondary'}
                                        style={{
                                            borderRadius: '100px',
                                            padding: '0px',
                                            height: '14px',
                                            width: '14px',
                                            marginTop: '-12px',
                                        }}
                                        onClick={(evt) =>
                                            handleOpacityMinusBtnClick(evt)
                                        }
                                    >
                                        <AiOutlineMinus
                                            id={item.id}
                                            size={10}
                                            style={{
                                                marginTop: '-14px',
                                                zIndex: -1,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Button>
                                    <span>
                                        <MdOutlineGradient
                                            size={17}
                                            rotation={90}
                                            style={{
                                                marginTop: '-12px',
                                                transform: 'rotate(-90deg)',
                                            }}
                                        />
                                    </span>
                                    <Button
                                        id={item.id}
                                        variant={'outline-secondary'}
                                        className={'me-1'}
                                        style={{
                                            borderRadius: '100px',
                                            padding: '0px',
                                            height: '15px',
                                            width: '15px',
                                            marginTop: '-12px',
                                        }}
                                        onClick={(evt) =>
                                            handleOpacityPlusBtnClick(evt)
                                        }
                                    >
                                        <AiOutlinePlus
                                            id={item.id}
                                            size={10}
                                            style={{
                                                marginTop: '-14px',
                                                zIndex: -1,
                                                pointerEvents: 'none',
                                            }}
                                        />
                                    </Button>
                                </>
                            )}
                        </div>
                    )}
                    {hasChildren(item) && (
                        <span className={'me-2'} onClick={() => toggle()}>
                            {selected ? '▼' : '▶'}
                        </span>
                    )}
                    <span style={{ marginTop: '-1px' }}>{item.title}</span>
                </div>
                {selected && (
                    <div style={{ marginLeft: '10px' }}>
                        {hasChildren(item) && renderNestedLevels(item.children)}
                    </div>
                )}
            </div>
        );
    };

    const NestedCollapse = ({ dataTree }) => {
        const renderNestedLevels = (data) => {
            return data.map((item, itemIndex) => (
                <SubLevelComp
                    item={item}
                    renderNestedLevels={renderNestedLevels}
                    key={itemIndex}
                />
            ));
        };
        return renderNestedLevels(dataTree);
    };

    return (
        <Accordion
            defaultActiveKey="0"
            className="control-panel-accord layer-control-accord"
            style={props.style}
        >
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    <span className={'accord-title'}>Data Layers</span>
                </Accordion.Header>
                <Accordion.Body
                    className={'mt-0 pt-2 pb-2'}
                    style={{
                        paddingLeft: '10px',
                        paddingRight: '10px',
                    }}
                >
                    <div
                        className={'mb-2'}
                        style={{
                            // marginLeft: '-10px',
                        }}
                    >
                        <Button
                            className={'me-2'}
                            variant={'outline-primary'}
                            size={'sm'}
                            style={{
                                borderRadius: '5px',
                                width: '145px',
                            }}
                            onClick={() => handleShowAllLayersBtnClick()}
                        >
                            <IoLayersSharp className={'me-2'} size={20} />
                            Show All
                        </Button>
                        <Button
                            className={''}
                            variant={'outline-primary'}
                            size={'sm'}
                            style={{
                                borderRadius: '5px',
                                width: '145px',
                            }}
                            onClick={() => handleHideAllLayersBtnClick()}
                        >
                            <SlLayers className={'me-2'} size={18} />
                            Hide All
                        </Button>
                    </div>
                    <div
                        className={'layer-control-body'}
                        style={{
                            paddingLeft: '0px',
                        }}
                    >
                        <NestedCollapse dataTree={props.layerTree} />
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}
export default React.memo(LayerControl);
